import React from "react";

import TopicItem from "./TopicItem";

const TopicList = ({ topics }) => {
  return (
    <>
      <div className="flex flex-col">
        <h2 className="text-[28px] font-semibold text-textPrimary leading-[40px]">
          Weekly Examination
        </h2>
        <span className="text-textSecondary text-sm">Available topics:</span>
      </div>

      {/* Topics section */}
      <div className="grid md:grid-cols-12 sm:grid-cols-8 grid-cols-4 gap-12">
        {topics?.map((topic) => (
          <TopicItem key={topic._id} topic={topic} />
        ))}
      </div>
    </>
  );
};

export default TopicList;
